/*
* avayaWebRTC Client Internal Library version 3.4
*
* Copyright 2015, Avaya Inc
*/

var RTCPeerConnection = null;
var getMediaDevices = null;
var getUserMedia = null;
var attachMediaStream = null;
var reattachMediaStream = null;
var webrtcDetectedBrowser = null;
var webrtcDetectedVersion = null;
var requestAnimationFrame = null;
var attachFile = null;
var detachMediaStream = null;

var FIREFOXBROWSER = "firefox";
var CHROMEBROWSER = "chrome";
var OPERABROWSER = "opera";
var INVALIDIP = "0.0.0.0";
var AUDIOMLINE = "m=audio";
var VIDEOMLINE = "m=video";
var CANDIDATEZEROLINE = "a=candidate:0 1 UDP";
var INVALIDSDP = 'invalid sdp';
var CLINE = "c=IN IP4";

var ___internals = new avayaWebRTCInternals();
___internals.SetupEnvironment();

//////////////////////////////////////////////////////////////////////////////////////////////////////////
//  Internal Global Methods Code
/***********************************************************************************
*   internal code for avayaWebRTC library
*/
function avayaWebRTCInternals() {
    /***********************************************************************************
    *   SetupEnvironment
    *	for webrtc APIs in different browsers or versions
    *   Currently supports only Chrome and FireFox
    *   include some jscripts like socket.io jquery etc...
    */
    this.SetupEnvironment = function () {
        //Audio Context
        window.AudioContext = window.AudioContext || window.webkitAudioContext || window.oAudioContext || window.mozAudioContext;

        if (navigator.mozGetUserMedia) {
            webrtcDetectedBrowser = FIREFOXBROWSER;
            webrtcDetectedVersion =
           parseInt(navigator.userAgent.match(/Firefox\/([0-9]+)\./)[1], 10);

            //request animation frame
            requestAnimationFrame = requestAnimationFrame;


            // The RTCPeerConnection object.
            RTCPeerConnection = mozRTCPeerConnection;

            // The RTCSessionDescription object.
            RTCSessionDescription = mozRTCSessionDescription;

            // The RTCIceCandidate object.
            RTCIceCandidate = mozRTCIceCandidate;

            // Get UserMedia (only difference is the prefix).
            // Code from Adam Barth.
            getMediaDevices = navigator.mediaDevices;

            // Creates iceServer from the url for FF.
            createIceServer = function (url, username, password) {
                var iceServer = null;
                var url_parts = url.split(':');
                if (url_parts[0].indexOf('stun') === 0) {
                    // Create iceServer with stun url.
                    iceServer = { 'url': url };
                } else if (url_parts[0].indexOf('turn') === 0) {
                    if (webrtcDetectedVersion < 27) {
                        // Create iceServer with turn url.
                        // Ignore the transport parameter from TURN url for FF version <=27.
                        var turn_url_parts = url.split("?");
                        // Return null for createIceServer if transport=tcp.
                        if (turn_url_parts[1].indexOf('transport=udp') === 0) {
                            iceServer = { 'url': turn_url_parts[0],
                                'credential': password,
                                'username': username
                            };
                        }
                    } else {
                        // FF 27 and above supports transport parameters in TURN url,
                        // So passing in the full url to create iceServer.
                        iceServer = { 'url': url,
                            'credential': password,
                            'username': username
                        };
                    }
                }
                return iceServer;
            };

            // Attach a file to an element.
            attachFile = function (element, url) {
                //element.mozSrcObject = url;
                //if (url.trim() !== "")
                //    element.play();
                if (typeof element.src !== 'undefined') {
                    if (url.trim() !== "") {
                        element.src = url;
                        element.play();
                    }
                    else {
                        element.pause();
                        //element.src = '';
                    }
                }

            };

            // Attach a media stream to an element.
            attachMediaStream = function (element, stream) {
                //console.log("Attaching media stream");
                element.mozSrcObject = stream;
                element.play();
            };

            reattachMediaStream = function (to, from) {
                //console.log("Reattaching media stream");
                to.mozSrcObject = from.mozSrcObject;
                to.play();
            };

            detachMediaStream = function (element) {
                attachFile(element, "");
            }

            // Fake get{Video,Audio}Tracks
            if (!MediaStream.prototype.getVideoTracks) {
                MediaStream.prototype.getVideoTracks = function () {
                    return [];
                };
            }

            if (!MediaStream.prototype.getAudioTracks) {
                MediaStream.prototype.getAudioTracks = function () {
                    return [];
                };
            }
        } else if (navigator.webkitGetUserMedia) {
            webrtcDetectedBrowser = CHROMEBROWSER;
            webrtcDetectedVersion =
         parseInt(navigator.userAgent.match(/Chrom(e|ium)\/([0-9]+)\./)[2], 10);

            // Creates iceServer from the url for Chrome.
            var createIceServer = function (url, username, password) {
                var iceServer = null;
                var url_parts = url.split(':');
                if (url_parts[0].indexOf('stun') === 0) {
                    // Create iceServer with stun url.
                    iceServer = { 'url': url };
                } else if (url_parts[0].indexOf('turn') === 0) {
                    // Chrome M28 & above uses below TURN format.
                    iceServer = { 'url': url,
                        'credential': password,
                        'username': username
                    };
                }
                return iceServer;
            };

            //request animation frame
            requestAnimationFrame = webkitRequestAnimationFrame;

            // The RTCPeerConnection object.
            //make the peer class behave similar for every browser type
            RTCPeerConnection = webkitRTCPeerConnection;

            // Get UserMedia (only difference is the prefix).
            // Code from Adam Barth.
            getUserMedia = navigator.webkitGetUserMedia.bind(navigator);

            // Attach a file to an element.
            attachFile = function (element, url) {
                if (typeof element.src !== 'undefined') {
                    element.src = url;
                    if (url.trim() !== "")
                        element.autoplay = true;
                }
            };

            // Attach a media stream to an element.
            attachMediaStream = function (element, stream) {
                if (typeof element.srcObject !== 'undefined') {
                    element.srcObject = stream;
                } else if (typeof element.mozSrcObject !== 'undefined') {
                    element.mozSrcObject = stream;
                } else if (typeof element.src !== 'undefined') {
                    element.src = URL.createObjectURL(stream);
                } else {
                    console.log('Error attaching stream to element.');
                }
            };

            reattachMediaStream = function (to, from) {
                to.src = from.src;
            };

            detachMediaStream = function (element) {
                attachFile(element, "");
            }

        }
        else if (navigator.oGetUserMedia) {
                webrtcDetectedBrowser = OPERABROWSER;
                webrtcDetectedVersion =
                    parseInt(navigator.userAgent.match(/Opera\/([0-9]+)\./)[1], 10);

                //request animation frame
                requestAnimationFrame = oRequestAnimationFrame;


                // The RTCPeerConnection object.
                RTCPeerConnection = oRTCPeerConnection;

                // The RTCSessionDescription object.
                RTCSessionDescription = oRTCSessionDescription;

                // The RTCIceCandidate object.
                RTCIceCandidate = oRTCIceCandidate;

                // Get UserMedia (only difference is the prefix).
                // Code from Adam Barth.
                getUserMedia = navigator.oGetUserMedia.bind(navigator);

                // Attach a file to an element.
                attachFile = function (element, url) {
                    if (typeof element.src !== 'undefined') {
                        element.src = url;
                        if (url.trim() !== "")
                            element.play();
                    }
                };

                // Attach a media stream to an element.
                attachMediaStream = function (element, stream) {
                    //console.log("Attaching media stream");
                    element.oSrcObject = stream;
                    element.play();
                };

                reattachMediaStream = function (to, from) {
                    //console.log("Reattaching media stream");
                    to.oSrcObject = from.mozSrcObject;
                    to.play();
                };

                detachMediaStream = function (element) {
                    attachFile(element, "");
                }

                // Fake get{Video,Audio}Tracks
                if (!MediaStream.prototype.getVideoTracks) {
                    MediaStream.prototype.getVideoTracks = function () {
                        return [];
                    };
                }

                if (!MediaStream.prototype.getAudioTracks) {
                    MediaStream.prototype.getAudioTracks = function () {
                        return [];
                    };
                }
        } else {
            webrtcDetectedBrowser = "OTHER";
                //throw new Error("Browser does not appear to be WebRTC - capable.");
                console.log("throw new Error: Browser does not appear to be WebRTC - capable.");
            }
    }
    
    /******************************************************************************************************************/
    // Private array of chars to use
    var CHARS = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz'.split('');
    this.createUuid = function () {
        var len = 0, radix = 16;
        var chars = CHARS, uuid = [], i;
        radix = radix || chars.length;

        if (len) {
            // Compact form
            for (i = 0; i < len; i++) uuid[i] = chars[0 | Math.random() * radix];
        } else {
            // rfc4122, version 4 form
            var r;

            // rfc4122 requires these characters
            uuid[8] = uuid[13] = uuid[18] = uuid[23] = '-';
            uuid[14] = '4';

            // Fill in random data.  At i==19 set the high bits of clock sequence as
            // per rfc4122, sec. 4.1.5
            for (i = 0; i < 36; i++) {
                if (!uuid[i]) {
                    r = 0 | Math.random() * 16;
                    uuid[i] = chars[(i == 19) ? (r & 0x3) | 0x8 : r];
                }
            }
        }

        return uuid.join('');
    }
    /******************************************************************************************************************/
    this.updateCLineIPAndMLinePort = function (sdp, onSuccessCB, onErrorCB) {
        //find c line position block
        var cLinePosition = sdp.indexOf(CLINE);
        if (cLinePosition < 0) {
            if (onErrorCB != undefined && onErrorCB != null)
                onErrorCB(INVALIDSDP);
            return;
        }

        var endOfCLineRow = sdp.indexOf("\n", cLinePosition);
        if (endOfCLineRow < 0 || cLinePosition >= sdp.length) {//bad sdp
            if (onErrorCB != undefined && onErrorCB != null)
                onErrorCB(INVALIDSDP);
            return;
        }
        
        //Get the IPAddress in c line
        var cLineRow = sdp.substring(cLinePosition, endOfCLineRow + 1);
        var cLineRowArray = cLineRow.split(' ');
        
        if (cLineRowArray[2].indexOf(INVALIDIP) >= 0) {
            var candidateZeroLinePosition = sdp.indexOf(CANDIDATEZEROLINE);
            if (candidateZeroLinePosition < 0) {
                if (onErrorCB != undefined && onErrorCB != null)
                    onErrorCB(INVALIDSDP);
                return;
            }    

            var endOfCandidateZeroLineRow = sdp.indexOf("\n", candidateZeroLinePosition);
            if (endOfCandidateZeroLineRow < 0 || endOfCandidateZeroLineRow >= sdp.length) {//bad sdp
                if (onErrorCB != undefined && onErrorCB != null)
                    onErrorCB(INVALIDSDP);
                return;
            }
        
            //Get the IPAddress and port from first candidate
            var candidateZeroLineRow = sdp.substring(candidateZeroLinePosition, endOfCandidateZeroLineRow + 1);
            var candidateZeroLineRowArray = candidateZeroLineRow.split(' ');
            var candidatePublicIP = candidateZeroLineRowArray[4];
            var candidatePort = candidateZeroLineRowArray[5];
            
            sdp = sdp.substring(0, cLinePosition) + CLINE + " " + candidatePublicIP + "\r\n" + sdp.substring(endOfCLineRow + 1);
            
            //find audio block
            var updatedAudioMediaPosition = sdp.indexOf(AUDIOMLINE);
            if (updatedAudioMediaPosition < 0){
                if (onSuccessCB != undefined && onSuccessCB != null)
                    onSuccessCB(sdp);
                return;
            }

            var endOfUpdatedAudioMediaRow = sdp.indexOf("\n", updatedAudioMediaPosition);
            if (endOfUpdatedAudioMediaRow < 0 || updatedAudioMediaPosition >= sdp.length) {//bad sdp
                if (onErrorCB != undefined && onErrorCB != null)
                    onErrorCB(INVALIDSDP);
                return;
            }
            var updatedAudioMediaRow = sdp.substring(updatedAudioMediaPosition, endOfUpdatedAudioMediaRow + 1);
            var audioMediaRowArray = updatedAudioMediaRow.split(' ');
            
            audioMediaRowArray.splice(1, 1, candidatePort);
            updatedAudioMediaRow = audioMediaRowArray.join(' ');
            sdp = sdp.substring(0, updatedAudioMediaPosition) + updatedAudioMediaRow + sdp.substring(endOfUpdatedAudioMediaRow + 1);
            
        }
        
        if (onSuccessCB != undefined && onSuccessCB != null)
            onSuccessCB(sdp);
    }
    
    /******************************************************************************************************************/
    this.addIceCandidateToSDP = function (sdp, candidateMediaType, candidateSdp, onSuccessCB, onErrorCB) {
        if (candidateMediaType !== "audio" && candidateMediaType !== "video" && !(sdp instanceof String) && !(candidateSdp instanceof String)) {
            if (onErrorCB != undefined && onErrorCB != null)
                onErrorCB('invalid input');
            return;
        }

        var audioMediaPosition = sdp.indexOf(AUDIOMLINE);
        var audioRtcpMuxPosition = sdp.indexOf("a=rtcp-mux", audioMediaPosition);
        var videoMediaPosition = sdp.indexOf(VIDEOMLINE);
        var videoRtcpMuxPosition = sdp.indexOf("a=rtcp-mux", videoMediaPosition);
        var nextMediaPosition = sdp.length - 1;
        var insertionPosition = sdp.length - 1;

        switch (candidateMediaType) {
            case "audio":
                if (audioMediaPosition < 0) {
                    if (onErrorCB != undefined && onErrorCB != null)
                        onErrorCB('Media type ' + candidateMediaType + ' not found in sdp');
                    return;
                }

                if (videoMediaPosition > audioMediaPosition)
                    nextMediaPosition = videoMediaPosition;

                //we prefer to add candidate just before a=rtcp-mux, if not existing add in the end of block
                if (audioRtcpMuxPosition >= 0 && audioRtcpMuxPosition <= nextMediaPosition)
                    insertionPosition = audioRtcpMuxPosition;
                else
                    insertionPosition = nextMediaPosition;
                break;
            case "video":
                if (videoMediaPosition < 0) {
                    if (onErrorCB != undefined && onErrorCB != null)
                        onErrorCB('Media type ' + candidateMediaType + ' not found in sdp');
                    return;
                }
                if (audioMediaPosition > videoMediaPosition)
                    nextMediaPosition = audioMediaPosition;

                //we prefer to add candidate just before a=rtcp-mux, if not existing add in the end of block
                if (videoRtcpMuxPosition >= 0 && videoRtcpMuxPosition <= nextMediaPosition)
                    insertionPosition = videoRtcpMuxPosition;
                else
                    insertionPosition = nextMediaPosition;
                break;
        }

        var fixedSdp;
        if (sdp.indexOf(candidateSdp) != -1) {
            fixedSdp = sdp;
        }
        else {
            fixedSdp = sdp.substring(0, insertionPosition) + candidateSdp + "\n" + sdp.substring(insertionPosition);
        }
        if (onSuccessCB != undefined && onSuccessCB != null) {
            onSuccessCB(fixedSdp)
        }
    }
    /******************************************************************************************************************/
    this.getURLParameters = function getURLParameters(paramName) {
        var sURL = decodeURIComponent(window.document.URL.toString());
        if (sURL.indexOf("?") > 0) {
            var arrParams = sURL.split("?");
            var arrURLParams = arrParams[1].split("&");
            var arrParamNames = new Array(arrURLParams.length);
            var arrParamValues = new Array(arrURLParams.length);
            var i = 0;
            for (i = 0; i < arrURLParams.length; i++) {
                var sParam = arrURLParams[i].split("=");
                arrParamNames[i] = sParam[0];
                if (sParam[1] != "")
                    arrParamValues[i] = unescape(sParam[1]);
                else
                    arrParamValues[i] = "No Value";
            }

            for (i = 0; i < arrURLParams.length; i++) {
                if (arrParamNames[i] == paramName) {
                    return arrParamValues[i];
                }
            }
            return undefined;
        }
    }
    /******************************************************************************************************************/
}
/******************************************************************************************************************/
module.exports.___internals = ___internals;
module.exports.webrtcDetectedBrowser = webrtcDetectedBrowser;
module.exports.webrtcDetectedVersion = webrtcDetectedVersion;
module.exports.CHROMEBROWSER = CHROMEBROWSER;

module.exports.FIREFOXBROWSER = FIREFOXBROWSER;
module.exports.CHROMEBROWSER = CHROMEBROWSER;
module.exports.OPERABROWSER = OPERABROWSER;
module.exports.INVALIDIP = INVALIDIP;
module.exports.AUDIOMLINE = AUDIOMLINE;
module.exports.VIDEOMLINE = VIDEOMLINE;
module.exports.CANDIDATEZEROLINE = CANDIDATEZEROLINE;
module.exports.INVALIDSDP = INVALIDSDP;
module.exports.CLINE = CLINE;

module.exports.getMediaDevices = getMediaDevices;
module.exports.getUserMedia = getUserMedia;
module.exports.attachMediaStream = attachMediaStream;
module.exports.reattachMediaStream = reattachMediaStream;
module.exports.webrtcDetectedBrowser = webrtcDetectedBrowser;
module.exports.webrtcDetectedVersion = webrtcDetectedVersion;
module.exports.requestAnimationFrame = requestAnimationFrame;
module.exports.RTCPeerConnection = RTCPeerConnection;

module.exports.attachFile = attachFile;
module.exports.detachMediaStream = detachMediaStream;


// WEBPACK FOOTER //
// ./src/call/avayawebrtc-client-internals.js